import React from 'react';
import { IFormItem } from '../RegistrationFormTypes';
import { RegistrationFormItems } from '../RegistrationFormItems';

type LogInFormProps = {
	getFormItem: (item: IFormItem, substituteLabel?: JSX.Element) => void;
};

export default function LogInForm({ getFormItem }: LogInFormProps) {
	return (
		<>
			{getFormItem(RegistrationFormItems.Email)}
			{getFormItem(RegistrationFormItems.Password)}
		</>
	);
}
